import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { MdVisibility } from "react-icons/md";
import { MdVisibilityOff } from "react-icons/md";

import _constantUtil from '../utils/Constant';
import Loader from '../components/partials/Loader';
import config from '../config/config';
import mobileBar from '../assets/images/232213.jpg'

const {
    BOOLEAN_FALSE: falseValue,
    BOOLEAN_TRUE: trueValue,
    EMPTY_STRING: emptyString,
    FORGOT_PASSWORD_END_POINT,
} = _constantUtil;

function ForgotPassword() {
    const [email, setEmail] = useState(emptyString);
    const [loading, setLoading] = useState(falseValue);
    const [otpSent, setOtpSent] = useState(falseValue);
    const [disableButton, setDisableButton] = useState(falseValue);
    const navigate = useNavigate();

    //* navigate to email verification
    useEffect(() => {
        if (otpSent) {
            navigate('/send-otp', { state: { email } });
        }
    }, [otpSent, navigate, email]);

    //* execute send otp api
    function executeSendOTPapi(event) {
        //* prevent default
        event.preventDefault();

        //* email is required validation
        if (!email) {
            toast.error('Email is required!');
            return;
        }

        setLoading(trueValue);
        setDisableButton(trueValue)
        const data = { email };

        //* api url
        const apiUrl = config.appBaseUrl + FORGOT_PASSWORD_END_POINT;

        //* send otp
        axios.post(apiUrl, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            const result = res.data;
            if (result.status) {
                toast.success(result.message);
                setTimeout(() => {
                    setOtpSent(trueValue);
                    setLoading(falseValue);
                    setDisableButton(falseValue);
                }, 1500);
            } else {
                toast.error(result.message);
                setLoading(falseValue);
                setDisableButton(falseValue);
            }
        }).catch(error => {
            toast.error(error.response?.data?.message);
            setLoading(falseValue);
            setDisableButton(falseValue);
        });
    }
    return (
        <>
            <ToastContainer autoClose={1000} position='top-center' />
            <div className="grid">
                <div className="order__left centered d-flex align-items-center justify-content-center">
                    <form onSubmit={executeSendOTPapi}>
                        <div className="form">
                            <div className="logo">
                                <h3 className='text-center'>Hire a Vendor for professionals</h3>
                            </div>
                            <div className="d-flex align-items-center justify-content-center">
                                <p className='text-center'>Please enter your email address to forgot your password.</p>
                            </div>
                            <input
                                type="text"
                                id="username"
                                name="username"
                                placeholder="Enter your email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                autoComplete="off"
                            />
                            <button type="submit" className="login__button" disabled={disableButton}>
                                {!loading ? 'Submit' : <Loader />}
                            </button>
                            <div className="signup">
                                <label className="remember_me">Already have an account?</label>
                                <Link
                                    to="/login"
                                    className="forgot__password text-golden"
                                    style={{ textDecoration: "none" }}
                                >
                                    <strong>Login</strong>
                                </Link>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="order__right centered no__overflow d-none d-md-block">
                    <img
                        className="img"
                        src={mobileBar}
                        alt="picture"
                    />
                </div>
            </div>
        </>
    );
}

export default ForgotPassword;